import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Apply saved UI scale before first paint to prevent flash
const savedFontSize = localStorage.getItem("setting_font_size");
if (savedFontSize) {
  document.documentElement.style.setProperty("--app-font-size", savedFontSize);
}

// BANAMOB app hand-off. The phone app opens /banamob/prosheet/:docId in its
// own WebView with its access token in the URL fragment (never sent to the
// server). Accepted ONLY inside that WebView (its user-agent carries
// "BanamobApp") and only on that path — a normal browser following such a link
// is never signed in as someone else. The refresh token deliberately stays in
// the app: the app re-injects fresh access tokens via window.__banamobToken.
if (/BanamobApp/.test(navigator.userAgent) && window.location.pathname.startsWith("/banamob/prosheet/")) {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const handed = params.get("t");
  if (handed) {
    localStorage.setItem("foundry-token", handed);
    localStorage.removeItem("foundry-refresh-token");
    localStorage.removeItem("foundry-expires-at");
    const theme = params.get("theme");
    if (["light", "dark", "system"].includes(theme)) localStorage.setItem("foundry-theme", theme);
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }
  window.__banamobToken = (t) => {
    if (typeof t === "string" && t) localStorage.setItem("foundry-token", t);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA (production only)
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered:', registration.scope);

          // Check for updates periodically
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000); // Check every hour

          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New content available, refresh to update.');
              }
            });
          });
        })
        .catch((error) => {
          console.log('SW registration failed:', error);
        });
    });
  } else {
    // In development, unregister any existing service workers to prevent caching issues
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
        console.log('SW unregistered for development');
      });
    });
  }
}
